/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Nickname_HintInputs */

const vi_grower_nickname_hint = /** @type {(inputs: Grower_Nickname_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dùng để phân biệt các hộ trùng tên`)
};

/**

* @param {Grower_Nickname_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_nickname_hint = /** @type {((inputs?: Grower_Nickname_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Nickname_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_nickname_hint(inputs)
});